import { Injectable } from '@angular/core';
import { Firestore, docData, doc, DocumentReference } from '@angular/fire/firestore';
import { User } from './user';
import { ProfileType } from './profile-type';
import { first, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileTypeService {

  constructor(
    public firestore: Firestore
  ) {}

  getProfileTypes(userObservable: Observable<User|undefined>): Observable<ProfileType | undefined> {
    return userObservable
      .pipe(
        first(),
        switchMap(user => docData<ProfileType>(doc(this.firestore, 'profileTypes', user?.profileType?.toLowerCase() || 'free') as DocumentReference<ProfileType>)),
        first()
      );
  }
}
